import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import CentreCard from './CentreCard';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Container = styled.div`
  width: 1136px;
  padding-top: ${Spacings.SPACING_20B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_12B} ${Spacings.SPACING_4B} 0px
      ${Spacings.SPACING_4B};
  }
  ${mediaQuery.uptoTablet} {
    width: 100%;
    padding: ${Spacings.SPACING_12B} ${Spacings.SPACING_4B} 0px
      ${Spacings.SPACING_4B};
  }
`;

const FlagshipContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding-top: ${Spacings.SPACING_8B};
  gap: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoTablet} {
    grid-template-columns: auto auto;
  }
  ${mediaQuery.uptoMobile} {
    padding-top: ${Spacings.SPACING_6B};
    grid-template-columns: auto;
  }
`;

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_2B};
  align-items: center;
`;

const NearbyCentres = ({ nearbyCentresData }) => {
  const data = nearbyCentresData?.data;

  return (
    <Wrapper>
      {data !== null && data !== undefined && (
        <Container>
          <TitleWrapper>
            <Typography variant="h2" color="var(--color-i-black)">
              Centres near you
            </Typography>
          </TitleWrapper>
          <FlagshipContainer>
            {data?.map((centreData, index) => {
              return (
                <CentreCard
                  centreData={centreData}
                  key={`nearby_centre_${index}`}
                />
              );
            })}
          </FlagshipContainer>
        </Container>
      )}
    </Wrapper>
  );
};

export default NearbyCentres;
